<template>
  <div class='treeview'>
    <ul class="pl-1 pt-1">
      <tree-view-item v-for="it in list"
        ref="treeviewItem"
        :item="it"
        :key="it[idField]"
        :idField="idField"
        :startOpen="startOpen"
        :showCheckbox="showCheckbox"
        :serializer="serializer"
        :childrenField="childrenField"
        :checkboxField="checkboxField"
        :iconBeforeName="iconBeforeName"
        @selectall="onSelectAll"
        v-on:open="onOpen"
        v-on:selectitem="onSelectItem" >
        <slot :item="it"></slot>
      </tree-view-item>
    </ul>
  </div>
</template>

<script>
import TreeViewItem from './TreeViewItem.vue'

export default {
  name: 'TreeView',
  model: {
    prop: 'list'
  },
  props: {
    list: {type: Array, required: true},
    startOpen: {type: Boolean, required: false, default: false},
    showCheckbox: {type: Boolean, required: false, default: false},
    serializer: {type: Function, required: true},
    childrenField: {type: String, required: false, default: 'children'},
    checkboxField: {type: String, required: false, default: 'checked'},
    idField: {type: String, required: false, default: 'id'},
    iconBeforeName: {type: String, required: false},
    close: {type: Boolean, required: false, default: false}
  },
  components: {
    TreeViewItem
  },
  methods: {
    closeAll () {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          i.closeAll()
        })
      }
    },
    openAll () {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          i.openAll()
        })
      }
    },
    onOpen (folder) {
      this.$emit('open', folder)
    },
    onSelectItem (item) {
      this.$emit('selectitem', item)
    },
    onSelectAll (field) {
      this.$emit('selectall', field)
    }
  },
  mounted () {
    console.log(this.close, this.startOpen)

    if (this.close === true) {
      this.startOpen = false
    }
  }
}
</script>

<style scoped>
.treeview {
  padding: 0px;
  background-color: #fff;
  width: 100%;
}

.treeview >>> ul li {
  list-style-type: none;
  width: 100%;
}

.treeview >>> treeview-item i,
a {
  font-size: 12px;
}

.treeview >>> .treeview-item {
  padding-top: 6px;
  padding-bottom: 2px;
  padding-right: 5px;
  padding-left: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.treeview >>> .treeview-item::not(.treeview-item-selected) {
  border-bottom: solid 1px #f5f5f5;
}

.treeview >>> .treeview-item-icon {
  padding-right: 6px;
}
.treeview >>> .treeview-item-icon.fa-angle-right {
  padding-right: 8px;
}

* >>> .pl0 {
  padding-left: 0px;
}
* >>> .pr5 {
  padding-right: 5px;
}
* >>> .pl5 {
  padding-left: 5px;
}
* >>> .pl10 {
  padding-left: 10px;
}
* >>> .pl15 {
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/treeview/TreeView.vue